// Import with * for better tree shaking
import * as FingerprintJS from '@fingerprintjs/fingerprintjs-pro';

export interface FingerprintConfig {
  token: string;
  endpoint: string;
}

export class Fingerprint {
  private fingerprintResult?: FingerprintJS.GetResult;

  constructor(private config: FingerprintConfig) {}

  public async init() {
    try {
      const fpLoad = await FingerprintJS.load({
        token: this.config.token,
        endpoint: this.config.endpoint,
        scriptUrlPattern: 'https://fp.sunbit.com/web/v3/XNZb6VbuXWRafpnwIsoQ/loader_v3.9.0.js',
      });

      const result = await fpLoad.get({ timeout: 20000 });
      this.fingerprintResult = result;
    } catch (e) {
      // because sometimes datadog is not ready yet to report this error, so we give it a bit more time
      setTimeout(() => {
        console.error('Fingerprint.init() failed', e);
      }, 1000);
    }
  }

  public getFingerprintResult() {
    return this.fingerprintResult || ({} as FingerprintJS.GetResult);
  }
}
